module.exports = __webpack_public_path__ + "img/2.2f838e6f.png";